import {Utilisateur} from './../../../interface/api/Utilisateur';
import {AuthentificationService} from './../../../core/services/authentification.service';
import { Component, OnInit, inject } from '@angular/core';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MandatsComponent } from '../mandats/mandats.component';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal-mes-mandats',
    template: `
    <h1 mat-dialog-title>{{'menu.mesMandats' | translate }}</h1>
    <mat-dialog-content>
      @if (user) {
        <app-mandats [profil]="user"></app-mandats>
      }
    </mat-dialog-content>
    
    <mat-dialog-actions>
      <button  mat-button [mat-dialog-close]="false">{{'general.close' | translate}}</button>
    </mat-dialog-actions>
    `,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MandatsComponent, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalMesMandatsComponent implements OnInit {
  private authService = inject(AuthentificationService);


  public user: Utilisateur;

  constructor() {
      this.user = this.authService.userConnected;
  }

  ngOnInit() {
  }

}
